"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

var _classCallCheck = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var ReactDOM = tslib_1.__importStar(require("react-dom"));

var dropdown_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Dropdown/dropdown"));

var react_styles_1 = require("@patternfly/react-styles");

var util_1 = require("../../helpers/util");

var dropdownConstants_1 = require("./dropdownConstants");

var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  var _super = _createSuper(DropdownMenu);

  function DropdownMenu() {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _super.apply(this, arguments);
    _this.refsCollection = [];

    _this.childKeyHandler = function (index, innerIndex, position) {
      var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      util_1.keyHandler(index, innerIndex, position, _this.refsCollection, _this.props.isGrouped ? _this.refsCollection : React.Children.toArray(_this.props.children), custom);
    };

    _this.sendRef = function (index, nodes, isDisabled, isSeparator) {
      _this.refsCollection[index] = [];
      nodes.map(function (node, innerIndex) {
        if (!node) {
          _this.refsCollection[index][innerIndex] = null;
        } else if (!node.getAttribute) {
          // eslint-disable-next-line react/no-find-dom-node
          _this.refsCollection[index][innerIndex] = ReactDOM.findDOMNode(node);
        } else if (isDisabled || isSeparator) {
          _this.refsCollection[index][innerIndex] = null;
        } else {
          _this.refsCollection[index][innerIndex] = node;
        }
      });
    };

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;

      if (autoFocus) {
        // Focus first non-disabled element
        var focusTargetCollection = this.refsCollection.find(function (ref) {
          return ref && ref[0] && !ref[0].hasAttribute('disabled');
        });
        var focusTarget = focusTargetCollection && focusTargetCollection[0];

        if (focusTarget && focusTarget.focus) {
          setTimeout(function () {
            return focusTarget.focus();
          });
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // reset refsCollection before updating to account for child removal between mounts
      this.refsCollection = [];
      return true;
    }
  }, {
    key: "extendChildren",
    value: function extendChildren() {
      var _this$props = this.props,
          children = _this$props.children,
          isGrouped = _this$props.isGrouped;

      if (isGrouped) {
        var index = 0;
        return React.Children.map(children, function (groupedChildren) {
          var group = groupedChildren;
          return React.cloneElement(group, Object.assign({}, group.props && group.props.children && {
            children: group.props.children.constructor === Array && React.Children.map(group.props.children, function (option) {
              return React.cloneElement(option, {
                index: index++
              });
            }) || React.cloneElement(group.props.children, {
              index: index++
            })
          }));
        });
      }

      return React.Children.map(children, function (child, index) {
        return React.cloneElement(child, {
          index: index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          isOpen = _a.isOpen,
          position = _a.position,
          children = _a.children,
          component = _a.component,
          isGrouped = _a.isGrouped,
          openedOnEnter = _a.openedOnEnter,
          setMenuComponentRef = _a.setMenuComponentRef,
          props = tslib_1.__rest(_a, ["className", "isOpen", "position", "children", "component", "isGrouped", "openedOnEnter", "setMenuComponentRef"]);

      return React.createElement(dropdownConstants_1.DropdownArrowContext.Provider, {
        value: {
          keyHandler: this.childKeyHandler,
          sendRef: this.sendRef
        }
      }, component === 'div' ? React.createElement(dropdownConstants_1.DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            menuClass = _ref.menuClass;
        return React.createElement("div", {
          className: react_styles_1.css(menuClass, position === dropdownConstants_1.DropdownPosition.right && dropdown_1["default"].modifiers.alignRight, className),
          hidden: !isOpen,
          onClick: function onClick(event) {
            return onSelect && onSelect(event);
          },
          ref: setMenuComponentRef
        }, children);
      }) : isGrouped && React.createElement(dropdownConstants_1.DropdownContext.Consumer, null, function (_ref2) {
        var menuClass = _ref2.menuClass,
            menuComponent = _ref2.menuComponent;
        var MenuComponent = menuComponent || 'div';
        return React.createElement(MenuComponent, Object.assign({}, props, {
          className: react_styles_1.css(menuClass, position === dropdownConstants_1.DropdownPosition.right && dropdown_1["default"].modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu",
          ref: setMenuComponentRef
        }), _this2.extendChildren());
      }) || React.createElement(dropdownConstants_1.DropdownContext.Consumer, null, function (_ref3) {
        var menuClass = _ref3.menuClass,
            menuComponent = _ref3.menuComponent;
        var MenuComponent = menuComponent || component;
        return React.createElement(MenuComponent, Object.assign({}, props, {
          className: react_styles_1.css(menuClass, position === dropdownConstants_1.DropdownPosition.right && dropdown_1["default"].modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu",
          ref: setMenuComponentRef
        }), _this2.extendChildren());
      }));
    }
  }]);

  return DropdownMenu;
}(React.Component);

exports.DropdownMenu = DropdownMenu;
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = {
  className: '',
  isOpen: true,
  openedOnEnter: false,
  autoFocus: true,
  position: dropdownConstants_1.DropdownPosition.left,
  component: 'ul',
  isGrouped: false,
  setMenuComponentRef: null
};